<p-galleria
  #galleria
  (activeIndexChange)="
    updateCloseBtnStyle(true); setupLoader(true); setGalleryNavigation(true)
  "
  [(visible)]="showGalleria"
  [(activeIndex)]="activeIndex"
  [baseZIndex]="20200"
  maskClass="photo-galleria-fullscreen-mask"
  [circular]="!isMobile"
  [containerStyle]="{ 'max-width': '100%', height: '100%', width: '100%' }"
  [fullScreen]="true"
  [ngClass]="{
    one: images.length === 1,
    two: images.length === 2,
    three: images.length === 3,
    desktop: showThumbnails,
    mobile: !showThumbnails
  }"
  [numVisible]="images.length < 5 ? images.length : 5"
  [showItemNavigators]="isMobile ? images?.length > 1 : images?.length > 2"
  [showThumbnails]="showThumbnails"
  [value]="images"
  class="photo-galleria-wrapper"
>
  <ng-template #item let-item>
    <img
      (load)="setupLoader(false, item); setGalleryNavigation(false)"
      *ngIf="!isDocument(item?.thumbnail); else docTemplate"
      [ngStyle]="{ height: showThumbnails ? '75vh' : 'auto' }"
      [src]="item?.file ? item.file : ''"
      alt=""
      style="object-fit: contain; display: block; width: 100%"
    />
    <ng-template #docTemplate>
      <ngx-doc-viewer
        (loaded)="
          updateCloseBtnStyle(); setupLoader(false); setGalleryNavigation(false)
        "
        [url]="item?.thumbnail"
        class="resume-modal"
        googleCheckContentLoaded="true"
        googleCheckInterval="3000"
        style="object-fit: contain; display: block; width: 100%; {{
          showThumbnails
            ? 'height: 75vh'
            : !isMobile
              ? 'height: auto'
              : 'height: 90vh'
        }}"
        viewerUrl="https://docs.google.com/guview?rl=%URL%&embedded=true"
      ></ngx-doc-viewer>
    </ng-template>
  </ng-template>
  <ng-template #thumbnail let-item>
    <div
      class="grid pb-0 pl-0 pr-0"
      style="position: relative"
    >
      <img
        [src]="getFilePreviewSrc(item?.thumbnail)"
        alt=""
        style="
          max-height: 200px;
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 10px;
          padding: 5px;
        "
      />
      <div
        (click)="downloadFile(item?.thumbnail)"
        [pTooltip]="'Download'"
        [tooltipDisabled]="!isDesktop"
        [tooltipPosition]="'top'"
        class="absolute right-0 bottom-0"
        style="
          background: rgba(0, 0, 0, 0.51);
          border-radius: 3px;
          padding: 7px 12px;
        "
      >
        <img
          alt="download"
          class="z-1"
          src="/assets/images/pitch-card-svg/download-icon.svg"
        />
      </div>
    </div>
  </ng-template>
</p-galleria>
